'use strict'

module.exports = (self) => require('../../runtime/add-from-fs-nodejs')(self)
